
import { AccountRole } from '../model/account-role';
import { AppSubscription } from '../model/subscription';
import { Instance } from '../model/instance';
import { environment } from 'src/environments/environment';

// ======================================================================
// questo oggetto può essere creato da una json.parse,
// in tal caso non viene creato un oggetto attrezzato anche dei metodi di questa classe,
// quindi i metodi che agiscono su un authorizationProperties
// vengono fatti  da AuthorizationPropertiesManager
export class AuthorizationProperties {
  jwtEncoded: string;
  accountName: string;
  accountEmail: string;
  language: string;
  regionalSettings: string;
  currentInstanceKey: string;
  roles: Array<AccountRole>;
  instances: Array<Instance>;
  subscriptions: Array<AppSubscription>;

  // --------------------------------------------------------------------------------
  constructor() {
    this.jwtEncoded = '';
    this.accountName = '';
    this.accountEmail = '';
    this.currentInstanceKey = '';
    this.language = '';
    this.regionalSettings = '';
    this.roles = new Array<AccountRole>();
    this.instances = new Array<Instance>();
    this.subscriptions = new Array<AppSubscription>();
  }
}

// ======================================================================
export class AppSecurityInfo {
  AppId: string;
  SecurityValue: string;

  constructor() {
    this.AppId = '';
    this.SecurityValue = '';
  }
}

// ======================================================================
export class AuthorizationInfo {

  authorizationProperties: AuthorizationProperties;
  sessionStorage: boolean;
  json;

  // --------------------------------------------------------------------------------
  constructor(jwt: string, accountName?: string) {
    this.authorizationProperties = new AuthorizationProperties();
    this.authorizationProperties.jwtEncoded = jwt;
    this.authorizationProperties.accountName = accountName;
    this.sessionStorage = environment.auth.sessionStorage
  }

  SetRolesFromStorage() {

    if (this.sessionStorage) {
      this.json = sessionStorage.getItem('M4_account_roles');
    }
    else {
      this.json = localStorage.getItem('M4_account_roles');
    }

    const roles: Array<AccountRole> = JSON.parse(this.json);
    roles.forEach(
      p => {
        this.authorizationProperties.roles.push(p);
      }
    );
  }
}
